exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".draggable-demo .draggable-container{margin:10px 30px;width:200px;height:200px;overflow:auto;border:1px solid #ccc}.draggable-demo .react-tree-item-dropped{animation:blink .6s linear infinite}@keyframes blink{50%{opacity:.5}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./examples/showcases/draggable.less
 ** module id = 234
 ** module chunks = 0
 **/